export default __webpack_public_path__ + "static/media/IMG_3081_8_11zon.ba3b384a.jpg";